module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Document type"), _c('SelectizeDocumentType', {
    attrs: {
      "max-items": 1,
      "selected-value": _vm.localValue.document_type_id
    },
    on: {
      "optionSelected": _vm.documentTypeSelected
    }
  })], 1), _c('label', [_vm._v("Document group"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.document_group),
      expression: "localValue.document_group"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localValue.document_group)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "document_group", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Maximum failed transactions"), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.maximum_client_failed_transactions),
      expression: "localValue.maximum_client_failed_transactions"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Transactions count (count|days 10|30)",
      "pattern": "[0-9]+\\|[0-9]+"
    },
    domProps: {
      "value": (_vm.localValue.maximum_client_failed_transactions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "maximum_client_failed_transactions", $event.target.value)
      }
    }
  })])])]), _c('label', [_vm._v("Driver bookings in last days"), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.minimum_bookings_in_last_days),
      expression: "localValue.minimum_bookings_in_last_days"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Reservation count (eg. count|days 10|30)"
    },
    domProps: {
      "value": (_vm.localValue.minimum_bookings_in_last_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "minimum_bookings_in_last_days", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Driver registration"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.minimum_driver_registration_seniority),
      expression: "localValue.minimum_driver_registration_seniority"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "Years of registration"
    },
    domProps: {
      "value": (_vm.localValue.minimum_driver_registration_seniority)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "minimum_driver_registration_seniority", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Driver age"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.minimum_driver_age),
      expression: "localValue.minimum_driver_age"
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.localValue.minimum_driver_age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "minimum_driver_age", $event.target.value)
      }
    }
  })])])]), _c('label', [_vm._v("Client minimum invoiced"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.minimum_client_invoiced),
      expression: "localValue.minimum_client_invoiced"
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.localValue.minimum_client_invoiced)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "minimum_client_invoiced", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Minimum document emission years"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.minimum_document_emission_years),
      expression: "localValue.minimum_document_emission_years"
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.localValue.minimum_document_emission_years)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "minimum_document_emission_years", $event.target.value)
      }
    }
  }), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-text"
  }, [_c('small', [_vm._v("Overrides global configuration")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cfd8cca!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/forms/DocumentRequirementForm.vue
// module id = 2360
// module chunks = 1